import { Flex, Modal, SectionMessage, Space, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import * as Styled from './styles'

export const LegalGuaranteeOfConformityModalBody = (): ReactElement => {
  const { t } = useTranslation()

  return (
    <Modal.Body>
      <Flex flexDirection="column" gap={Spacing.S8}>
        <Text variant="bodyLG" weight="semiBold">
          {t(
            'settings.organization.external_invoice.legal_mentions.legal_guarantee_of_conformity.modal.body.overview.title',
          )}
        </Text>
        <Text>
          {t(
            'settings.organization.external_invoice.legal_mentions.legal_guarantee_of_conformity.modal.body.overview.description',
          )}
        </Text>
        <SectionMessage>
          {t('settings.organization.external_invoice.legal_mentions.legal_guarantee_of_conformity.modal.body.message')}
        </SectionMessage>
        <Space size="s8" />
        <Text variant="bodyLG" weight="semiBold">
          {t(
            'settings.organization.external_invoice.legal_mentions.legal_guarantee_of_conformity.modal.body.statement_preview.title',
          )}
        </Text>
        <Styled.LegalGuaranteeOfConformityStatementPreview>
          <Text>
            {t(
              'settings.organization.external_invoice.legal_mentions.legal_guarantee_of_conformity.modal.body.statement_preview.description',
            )}
          </Text>
        </Styled.LegalGuaranteeOfConformityStatementPreview>
        <Text variant="bodySM" colorVariant="secondary">
          {t(
            'settings.organization.external_invoice.legal_mentions.legal_guarantee_of_conformity.modal.body.statement_preview.based_on',
          )}
        </Text>
        <Space size="s8" />
        <Text variant="bodyLG" weight="semiBold">
          {t(
            'settings.organization.external_invoice.legal_mentions.legal_guarantee_of_conformity.modal.body.categories.title',
          )}
        </Text>
        <Trans
          i18nKey="settings.organization.external_invoice.legal_mentions.legal_guarantee_of_conformity.modal.body.categories.list"
          components={{
            ul: <Styled.LegalGuaranteeOfConformityCategoriesList />,
            li: <li />,
          }}
        />
      </Flex>
    </Modal.Body>
  )
}
